import { useState, useEffect, useContext } from 'react';
import "../css/Modal.css"
import UserContext from "../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import FetchUtil from "../utils/FetchUtil";
import { scrollToTop } from "../utils/helper.js";
import { ddStyles } from "../utils/CommonStyles.js";

let subsidiaryOptions = [];

function SubsidiaryModal({ t, companyList, parentCompanyId, setShow, refetch }) {
	const [error, setError] = useState("");
	const [formErrors, setFormErrors] = useState([]);
	const [isSubmit, setIsSubmit] = useState(false);
	const userCtx = useContext(UserContext);
	const navigate = useNavigate();
	const [subsidiarySelected, setSubsidiarySelected] = useState({ name: "companyId", label: "", value: 0 });
	const [subsidiaryLoaded, setSubsidiaryLoaded] = useState(false);

	const submitText = t("page.submit");
	const closeText = t("page.close");


	useEffect(() => {
		setSubsidiaryValues();
		scrollToTop();
	}, []);

	function setSubsidiaryValues() {
		let subsidiaryValue = {};
		subsidiaryOptions = [];
		if (companyList && companyList.length > 0) {
			companyList.map((company, index) => {
				if (company.companyId !== parentCompanyId) {
					subsidiaryValue.label = company.companyName+ ', ' + (company.city? company.city + ', ': '') + company.stateCode + ', ' + company.countryCode;
					subsidiaryValue.value = company.companyId;
					subsidiaryOptions.push(subsidiaryValue);
					subsidiaryValue = {};
				}
			});
			setSubsidiaryLoaded(true);
		}
	}

	const subsidiaryHandler = (selectedOption, action) => {
		let subsidiaryId = selectedOption ? selectedOption.value : 0;
		let subsidiaryName = selectedOption ? selectedOption.label : "";
		setSubsidiarySelected({ ...subsidiarySelected, label: subsidiaryName, value: subsidiaryId });
	}

	const handleSubmit = (event) => {
		event.preventDefault();
		setIsSubmit(true);
		let errors = validateFields();
		setFormErrors(errors);
		if (!errors || errors.length === 0) {
			addSubsidiary();
		} else {
			setIsSubmit(false);
		}

	};
	const validateFields = () => {
		const errors = [];
		if (!subsidiarySelected.value || subsidiarySelected.value === 0) {
			errors.push(t("error.subsidiaryReqd"));
		}

		return errors;
	};
	const addSubsidiary = () => {
		let action = 1;

		let serverParams = {
			parentCompanyId: parentCompanyId,
			subsidiaryCompanyId: subsidiarySelected.value,
			source: "web",
			action: action,
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateSubsidiary", "/Service/CompanyService/AddUpdateSubsidiary", requestOptions, addSubsidiarySuccess, addSubsidiaryFail);
		} catch (error) {
			setError(error.message);
		}
	};

	function addSubsidiaryFail(redirect) {
		setIsSubmit(false);
		setError(t("error.companyEditFailed"));
	}
	function addSubsidiarySuccess(responseData) {
		setIsSubmit(false);
		let addUpdateSubsidiaryResponse;
		if (responseData) {
			addUpdateSubsidiaryResponse = responseData.addUpdateSubsidiaryResponse;
			if (addUpdateSubsidiaryResponse) {
				if (addUpdateSubsidiaryResponse.errorCode === "0") {
					setShow(false);
					refetch();
					navigate("/pages/subsidiaries");
				} else {
					setError(t("error.error") + " " +
						addUpdateSubsidiaryResponse.errorMessage
					);
				}
			}
		}
	}

	return (
		<>
		{(userCtx.role === "SiteAdmin"  ) ?
		<div className="modalContainer-sm hide-scrollbar">
			<div className="row">
				<div className="col mt-3">
					{((formErrors && formErrors.length > 0) || error) ? (
						<div id="inerrorMessage" className="errorblock">
							{((formErrors && formErrors.length > 0) ) ? (
								formErrors.map((errorData, index) => (
									<p className="message-line">{errorData}</p>
								))
							) : ""}
							{error}
						</div>
					):(<></>)}
				</div>
			</div>
			<div className="row">
				<div className="col">
					<form
						className="regn_form_container"
						acceptCharset="UTF-8"
						id="sign-up"
						onSubmit={handleSubmit}
					>
						<h2>{t("page.subsidiary.add")}
						</h2>

						<div className="row">
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										<span className="form_required">*</span>
										{t("page.subsidiary")}
									</label>
									<Select
										name="companyId"
										options={subsidiaryOptions}
										onChange={subsidiaryHandler}
										placeholder={""}
										value={subsidiarySelected}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="companyId-input"
										styles={ddStyles}
									/>
								</div>
							</div>
						</div>
						<div className="footer">
							<input
								type="button"
								name="edit-subsidiary-close"
								id="edit-subsidiary-close"
								className="btn btn-secondary btn-block" data-dismiss="modal"
								disabled={isSubmit}
								onClick={(e) => setShow(false)}
								style={{ marginRight: "50px" }}
								value={closeText}
							></input>

							<div id="submit-spinner"
								className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
							>  </div>
							<input
								type="submit"
								name="edit-submit"
								id="edit-submit"
								data-dismiss="modal"
								className={"btn btn-primary btn-block"}
								style={{ marginTop: "10px", marginBottom: "10px" }}
								value={submitText}
								disabled={isSubmit}
							>
							</input>

						</div>
					</form>
				</div>
			</div>
			<div className="row">
				<div className="col mt-3">
					{((formErrors && formErrors.length > 0) || error) ? (
						<div id="berrorMessage" className="errorblock">
							{((formErrors && formErrors.length > 0) ) ? (
								formErrors.map((errorData, index) => (
									<p className="message-line">{errorData}</p>
								))
							) : ""}
							{error}
						</div>
					):(<></>)}
				</div>
			</div>
			<div className="row">
				<div className="col">
					<div id="placeholder_1" className="placeholder-pg" style={{ height: "110px" }}></div>
				</div>
			</div>
		</div>
		: null}
		</>
	);
}

export default SubsidiaryModal;